var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13C6.48773 13 2.84919 10.7203 0.164314 7.0175C-0.0547714 6.71414 -0.0547714 6.29032 0.164314 5.98696C2.84919 2.27968 6.48773 0 10.5 0C14.5123 0 18.1508 2.27969 20.8357 5.9825C21.0548 6.28586 21.0548 6.70968 20.8357 7.01304C18.1508 10.7203 14.5123 13 10.5 13ZM10.7878 1.92279C8.12442 1.7488 5.92498 4.02848 6.09251 6.7989C6.22998 9.08305 8.01273 10.9345 10.2122 11.0772C12.8756 11.2512 15.075 8.97152 14.9075 6.2011C14.7657 3.92141 12.983 2.07001 10.7878 1.92279ZM10.6546 4.03741C9.21985 3.94372 8.03421 5.17056 8.12872 6.6606C8.20175 7.8919 9.16401 8.88675 10.3496 8.96706C11.7844 9.06074 12.9701 7.8339 12.8756 6.34386C12.7983 5.1081 11.836 4.11325 10.6546 4.03741Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewUser);
export default __webpack_public_path__ + "static/media/viewUser.71445f9a8038042c7f7a994df17aa975.svg";
export { ForwardRef as ReactComponent };